import { call, takeLatest, put, select } from 'redux-saga/effects';
import {
  fetchNotificationRecipentsStart,
  fetchNotificationRecipentsSuccess,
  fetchNotificationRecipentsFailure,
  fetchNotificationTypesStart,
  fetchNotificationTypesSuccess,
  fetchNotificationTypesFailure,
  addNotificationRecipientStart,
  addNotificationRecipientSuccess,
  addNotificationRecipientFailure,
  fetchIndNotifsFailure,
  fetchIndNotifsSuccess,
  setSubmittingSuccess,
  fetchIndNotifsStart,
  editNotificationFailure,
  editNotificationStart,
  editNotificationSuccess
} from '../slices/notificationSlice';
import { apiGetCall, apiPostCall, apiPutCall } from '../api';
import { showAPIerror } from '../../pages/SellerProfile/APIs/Helpers';
import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { getStatus,setApiStatus,setShowSuccessPopUp } from '../slices/sellerProfileSlice';

const URL = process.env.REACT_APP_API_BASE;

function* checkTokenExpired() {
  // if (jwtDecode(token).exp < Date.now() / 1000) {
  yield (window.instance as any)
    .acquireTokenSilent({
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
      authority: process.env.REACT_APP_AZURE_AUTHORITY
    })
    .then((res) => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.idToken}`;
    })
    .catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        (window.instance as any).loginRedirect();
      }
    });
}

function* fetchNotificationTypesSaga(action) {
  try {
    yield call(checkTokenExpired);
    const response = yield call(apiGetCall, URL + 'notification-types');
    
    if (response.notifications) {
      yield put(fetchNotificationTypesSuccess([...response.notifications,...response.preferences]));
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(
      fetchNotificationTypesFailure(
        showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'fetchNotificationTypesSaga')
      )
    );
  }
}

function* fetchNotificationRecipentsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { seller_id } = yield select((state) => state.sellerProfile);
    const response = yield call(
      apiGetCall,
      URL + 'notification-list-contacts/' + seller_id
    );
    
    yield put(fetchNotificationRecipentsSuccess(response.data));
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(
      fetchNotificationRecipentsFailure(
        showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'fetchNotificationRecipentsSaga')
      )
    );
  }
}

function* addNotificationRecipientSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { updates } = action.payload;
    const newRecipient = {
      user_first_name: updates.user_first_name,
      user_last_name: updates.user_last_name,
      user_email: updates.user_email,
      user_opted_notifications: updates.notifications,
      notif_lang_pref: updates.notif_lang_pref
    };
    const { seller_id } = yield select((state) => state.sellerProfile);
    const response = yield call(
      apiPostCall,
      URL + 'notification-list-contact/' + seller_id,
      newRecipient
    );
    if (response.status === 'successful') {
      yield put(addNotificationRecipientSuccess(response.resp));
      yield put(getStatus({ seller_id }));
      yield put(fetchNotificationRecipentsStart());
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(
      addNotificationRecipientFailure(
        showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'addNotificationRecipientSaga')
      )
    );
  }
}

function* fetchIndNotifsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { curr_user_id } = action.payload;
    const response = yield call(
      apiGetCall,
      URL + 'notification-list-contact/' + curr_user_id
    );
    const finalData = response.notifUsersRows[0];
    yield put(fetchIndNotifsSuccess(finalData));
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(
      fetchIndNotifsFailure(
        showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'fetchIndNotifsSaga')
      )
    );
  }
}

function* editNotificationSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { curr_user_id, updates, notif_lang_pref } =
      action.payload;
    const { seller_id } = yield select((state) => state.sellerProfile);
    const response = yield call(
      apiPutCall,
      URL + 'notification-list-contact/' + curr_user_id,
      {
        user_opted_notifications: updates,
        notif_lang_pref: notif_lang_pref
      }
    );
    if (response.status === 'successful') {
      yield put(editNotificationSuccess(response));
      yield put(getStatus({ seller_id }));
      yield put(fetchNotificationRecipentsStart());
      yield put(setSubmittingSuccess(true));
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(
      editNotificationFailure(
        showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'editNotificationSaga')
      )
    );
  }
}

export default function* notificationSaga() {
  yield takeLatest(
    fetchNotificationRecipentsStart,
    fetchNotificationRecipentsSaga
  );
  yield takeLatest(fetchNotificationTypesStart, fetchNotificationTypesSaga);
  yield takeLatest(addNotificationRecipientStart, addNotificationRecipientSaga);
  yield takeLatest(fetchIndNotifsStart, fetchIndNotifsSaga);
  yield takeLatest(editNotificationStart, editNotificationSaga);
}
